<template>
  <div>
    <NavigationDashboard />
    <div class="dashboard-layout">
      <nuxt class="dashboard-layout-container" />
    </div>
    <Footer />

    <BikeAddModal />
    <EditBikeModal />
    <CreatePasswordModal />
    <BuildBadge />
  </div>
</template>

<script>
/* eslint-disable no-console */
// import MainNavigation from '@/components/MainNavigation'
import NavigationDashboard from '@/components/NavigationDashboard'
import BikeAddModal from '@/components/modals/BikeAdd'
import EditBikeModal from '@/components/modals/EditBike'
import CreatePasswordModal from '@/components/modals/CreatePassword'
import Footer from '@/components/common/Footer'
import BuildBadge from '@/components/common/BuildBadge'

import { buildSeoHead } from '@/helpers/seo'

export default {
  name: 'DashboardLayout',
  components: {
    BuildBadge,
    BikeAddModal,
    EditBikeModal,
    CreatePasswordModal,
    NavigationDashboard,
    Footer,
  },
  data() {
    return {}
  },
  head() {
    return {
      // Canonical (and noindex where the route has no search value) for every
      // page using this layout — see helpers/seo.js.
      ...buildSeoHead(this.$route.path),
      style: [
        { cssText: this.$store.getters['theme/theme'], type: 'text/css' },
      ],
    }
  },
  computed: {},
  mounted() {
    this.$store.dispatch('quote/setMtaFlag', true)
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.dashboard-layout {
  padding: 0;
  // The nav is a compact sticky bar now, so less room above the page.
  @include desktop {
    padding: 36px 60px 0 60px;
  }
}
.dashboard-layout-container {
  // padding-top: 20px;
  // @include desktop {
  //   padding-top: 30px;
  // }
}
</style>
